const AverageMonthlyPerforamanceReportTypes = {
  //*************************AVERAGE MONTHLY PERFORMANE REPORT FETCH START *********************//
  AVERAGE_MONTHLY_PERFORMANCE_REPORT_FETCH_START:
    "average_monthly_performance_report_fetch_start",
  AVERAGE_MONTHLY_PERFORMANCE_REPORT_FETCH_SUCCESS:
    "average_monthly_performance_report_fetch_success",
  AVERAGE_MONTHLY_PERFORMANCE_REPORT_FETCH_FAILURE:
    "average_monthly_performance_report_fetch_failure",
  AVERAGE_MONTHLY_PERFORMANCE_REPORT_FETCH_RESET_START:
    "average_monthly_performance_report_fetch_Reset_start",
  AVERAGE_MONTHLY_PERFORMANCE_REPORT_FETCH_RESPONSE_CHANGED:
    "average_monthly_performance_report_fetch_changed",

  //*************************AVERAGE MONTHLY PERFORMANE REPORT EXPORT START *********************//
  AVERAGE_MONTHLY_PERFORMANCE_REPORT_EXPORT_START:
    "average_monthly_performance_report_export_start",
  AVERAGE_MONTHLY_PERFORMANCE_REPORT_EXPORT_SUCCESS:
    "average_monthly_performance_report_export_success",
  AVERAGE_MONTHLY_PERFORMANCE_REPORT_EXPORT_FAILURE:
    "average_monthly_performance_report_export_failure",
  AVERAGE_MONTHLY_PERFORMANCE_REPORT_EXPORT_RESET_START:
    "average_monthly_performance_report_export_reset_start",
  AVERAGE_MONTHLY_PERFORMANCE_REPORT_EXPORT_CHANGED:
    "average_monthly_performance_report_export_changed",
};
export default AverageMonthlyPerforamanceReportTypes;
